import { Icon } from "@livingmap/hippo";

import styles from "./ZoomControl.module.css";

interface Props {
  dataQA: string;
  onZoomInClick: () => void;
  onZoomOutClick: () => void;
}

const ZoomControl: React.FC<Props> = ({
  dataQA,
  onZoomInClick,
  onZoomOutClick,
}) => {
  return (
    <div data-qa={dataQA} className={styles.container}>
      <div className={styles.button} onClick={onZoomInClick}>
        <Icon dataQA="plus-icon" size={24} name="plus" />
      </div>
      <div className={styles.button} onClick={onZoomOutClick}>
        <Icon dataQA="minus-icon" size={24} name="minus" />
      </div>
    </div>
  );
};

export default ZoomControl;
